import React from "react"
import { createDomMotionComponent } from "framer-motion"

import { Asset, Link } from "components"

const MotionLink = createDomMotionComponent(Link)

const cardVariants = {
  initial: {
    scale: 1,
    transition: { type: "spring", bounce: 0.25, duration: 1 },
  },
  hover: {
    scale: 1.025,
    transition: { type: "spring", bounce: 0.25, duration: 0.5 },
  },
}

function Card({ image, link, title }) {
  return (
    <li>
      <MotionLink
        className="block aspect-w-3 aspect-h-4 bg-mineralGray focus:outline-none"
        href={link?.link}
        initial="initial"
        whileHover="hover"
        whileFocus="hover"
        variants={cardVariants}
      >
        {image && (
          <Asset
            asset={image}
            objectFit="cover"
            objectPosition="center"
            style={{ position: "absolute" }}
          />
        )}
        <div className="bg-black opacity-25" />
        <p className="px-4 pt-4 text-white md:px-6 md:pt-6 h4">{title}</p>
      </MotionLink>
    </li>
  )
}

export default Card
